/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-danger */
import React, { useMemo } from 'react'
import useSettingsV2 from '../hooks/useSettingsV2'

function isObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

export default function HTML({ value, name, style, className }) {
  const { settings } = useSettingsV2()

  const props = useMemo(() => ({ style: { margin: '16px 0px', ...(style || {}) }, className }), [style, className])

  if (settings) {
    if (value) {
      return <div {...props} dangerouslySetInnerHTML={{ __html: value.html || value }} />
    }
    if (name && isObject(settings[name])) {
      return <div {...props} dangerouslySetInnerHTML={{ __html: settings[name].html }} />
    }
    if (name && typeof settings[name] === 'string') {
      return <div {...props} dangerouslySetInnerHTML={{ __html: settings[name] }} />
    }
  }

  return <div style={{ height: 16 }} />
}
